import './accordion.css';

import { AccordionMultipleProps, AccordionSingleProps, Root as AccordionRoot } from '@radix-ui/react-accordion';
import React from 'react';

import { cn } from '@/services/utils';

interface AccordionProps extends AccordionMultipleProps {
    value?: string[];
    onValueChange?: (value: string[]) => void;
}

const Accordion = React.forwardRef<
    React.ElementRef<typeof AccordionRoot>,
    AccordionProps
>(({ className, children, value, onValueChange, ...props }, ref) => (
    <AccordionRoot
        ref={ref}
        className={cn('scoped-accordion', className)}
        value={value}
        onValueChange={onValueChange}
        {...props}
    >
        {children}
    </AccordionRoot>
));

Accordion.displayName = 'Accordion';

interface AccordionSinglePropsInterface extends AccordionSingleProps {
}

const AccordionSingle = React.forwardRef<
    React.ElementRef<typeof AccordionRoot>,
    AccordionSinglePropsInterface
>(({ className, children, value, onValueChange, ...props }, ref) => (
    <AccordionRoot
        ref={ref}
        className={cn('scoped-accordion', className)}
        collapsible= {true}
        value={value}
        onValueChange={onValueChange}
        {...props}
    >
        {children}
    </AccordionRoot>
));

AccordionSingle.displayName = 'AccordionSingle';

export { Accordion, AccordionSingle };
